(function () {
  function init() {
    var nav = document.querySelector('.nav-bar .site-nav');
    if (!nav) return;
    var desktop = window.matchMedia('(min-width: 1025px)');
    var entries = [];
    Array.from(nav.children).forEach(function (item, index) {
      var link = Array.from(item.children).find(function (el) { return el.tagName === 'A'; });
      var panel = Array.from(item.children).find(function (el) { return el.classList.contains('site-nav-dropdown'); });
      if (!link || !panel) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ocu-nav-toggle';
      button.setAttribute('aria-label', link.textContent.trim() + ' submenu');
      button.setAttribute('aria-expanded', 'false');
      panel.id = 'ocu-desktop-submenu-' + index;
      button.setAttribute('aria-controls', panel.id);
      button.innerHTML = '<span aria-hidden="true">&#9662;</span>';
      link.insertAdjacentElement('afterend', button);
      item.setAttribute('data-ocu-dropdown', '');
      var entry = { item: item, link: link, panel: panel, button: button };
      entries.push(entry);
      function open() {
        entries.forEach(function (other) { if (other !== entry) close(other); });
        item.setAttribute('data-ocu-open', 'true');
        button.setAttribute('aria-expanded', 'true');
      }
      button.addEventListener('click', function () {
        if (!desktop.matches) return;
        if (button.getAttribute('aria-expanded') === 'true') close(entry);
        else open();
      });
      item.addEventListener('mouseenter', function () { if (desktop.matches) open(); });
      item.addEventListener('mouseleave', function () {
        if (desktop.matches && !item.contains(document.activeElement)) close(entry);
      });
      item.addEventListener('focusout', function (event) {
        if (desktop.matches && !item.contains(event.relatedTarget)) close(entry);
      });
      item.addEventListener('keydown', function (event) {
        if (!desktop.matches) return;
        if (event.key === 'Escape' && button.getAttribute('aria-expanded') === 'true') {
          event.preventDefault();
          close(entry);
          button.focus();
        } else if (event.key === 'ArrowDown' && (event.target === link || event.target === button)) {
          event.preventDefault();
          open();
          var first = panel.querySelector('a[href], button:not([disabled])');
          if (first) first.focus();
        }
      });
    });
    function close(entry) {
      entry.item.setAttribute('data-ocu-open', 'false');
      entry.button.setAttribute('aria-expanded', 'false');
    }
    function position() {
      entries.forEach(function (entry) {
        close(entry);
        if (!desktop.matches) return;
        var icon = entry.link.querySelector('.icon-dropdown');
        var box = (icon || entry.link).getBoundingClientRect();
        var parent = entry.button.offsetParent.getBoundingClientRect();
        entry.button.style.left = (box.right - parent.left - 21) + 'px';
        entry.button.style.top = (box.top - parent.top + box.height / 2 - 12) + 'px';
      });
    }
    document.addEventListener('click', function (event) {
      if (!nav.contains(event.target)) entries.forEach(close);
    });
    window.addEventListener('resize', position);
    position();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();